module.exports = __webpack_public_path__ + "media/images/last_page_horizontal_bg-b3743b4df1bcdb3ad8e7f0f59f4e93a7.png";